<template>
  <b-modal id="modal-customer-record" size="xl">
    <!--Content-->

    <template slot="modal-header">
      <div>
        <h2>
          {{ dealer.customer_history_record.CustomerRecord.FullName }}
        </h2>
      </div>
    </template>

    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col lg="12">
            <!-- <b-card>
        <div slot="header">User Profile</div>-->
            <b-form>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >Name</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord.FullName
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >Customer Number</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord
                            .DVCustomerNumber
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >Address</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord.Address1
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >Ste./Bldg</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord.Address2
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >City</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord.City
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >State</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord.State
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >Postal Code</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord
                            .PostalCode
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text class="standardizedWidth"
                          >Email</b-input-group-text
                        >
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="
                          dealer.customer_history_record.CustomerRecord.Email1
                        "
                        autocomplete="off"
                        type="text"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" class="mt-4">
                  <h2 class="text-shoppingCartBlue">
                    Total Expenditures:
                    {{
                      as_dollar_modal(
                        dealer.customer_history_record.LifetimeCustomerRevenue
                      )
                    }}
                  </h2>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" class="mt-4">
                  <h4>Purchases</h4>
                  <b-table
                    :items="dealer.customer_history_record.Purchases"
                    :fields="fields_sales_modal"
                    :tbody-tr-class="rowClassModalSales"
                    hover
                    small
                    fixed
                    caption
                    selectable
                    select-mode="single"
                    responsive="sm"
                    selectedVariant="success"
                    current-page="1"
                    per-page="1000"
                  >
                  </b-table>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" class="mt-4">
                  <h4>Service Visits</h4>
                  <b-table
                    :items="dealer.customer_history_record.ServiceVisits"
                    :fields="fields_service_modal"
                    :tbody-tr-class="rowClassModalService"
                    hover
                    small
                    fixed
                    caption
                    selectable
                    select-mode="single"
                    responsive="sm"
                    selectedVariant="success"
                    current-page="1"
                    per-page="1000"
                  >
                  </b-table>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">&nbsp;</b-col>
              </b-row>
            </b-form>
            <!-- </b-card> -->
          </b-col>
        </b-row>
      </b-card>
    </div>
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border:none;"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-customer-record')"
          aria-label="Close"
          >Close</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import cTable from "@/views/base/Table.vue";
//import ShipStatusRow from "@/components/CustomRowComponents/ShipStatusRow.vue";
export default {
  name: "CustomerHistoryRecord",
  data() {
    return {
      fields_sales_modal: [
        {
          key: "DateSold",
          label: "Sale Date",
          sortable: false,
          thStyle: "width: 10%;"
        },
        {
          key: "NewUsed",
          label: "New/Used",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "VIN",
          label: "VIN",
          sortable: true,
          thStyle: "width: 20%;"
        },
        {
          key: "VehicleYear",
          label: "Year",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "VehicleMake",
          label: "Make",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "VehicleModel",
          label: "Model",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "TotalProfit",
          label: "Revenue",
          sortable: true,
          thStyle: "width: 10%;"
        }
      ],
      fields_service_modal: [
        {
          key: "ROCloseDate",
          label: "RO Date",
          sortable: false,
          thStyle: "width: 10%;"
        },
        {
          key: "NewUsed",
          label: "",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "VIN",
          label: "VIN",
          sortable: true,
          thStyle: "width: 20%;"
        },
        {
          key: "VehicleYear",
          label: "Year",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "VehicleMake",
          label: "Make",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "VehicleModel",
          label: "Model",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "TotalSale",
          label: "Revenue",
          sortable: true,
          thStyle: "width: 10%;"
        }
      ]
    };
  },
  methods: {
    rowClassModalService(item, type) {
      if (!item || type !== "row") return;
      if (
        item.RODate >=
          this.$store.state.campaign.campaign_roi.CampaignStatHeader
            .ReportingStartDate &&
        item.RODate <=
          this.$store.state.campaign.campaign_roi.CampaignStatHeader
            .ReportingEndDate
      ) {
        return "table-success";
      }
    },
    rowClassModalSales(item, type) {
      if (!item || type !== "row") return;
      if (
        item.SaleDate >=
          this.$store.state.campaign.campaign_roi.CampaignStatHeader
            .ReportingStartDate &&
        item.SaleDate <=
          this.$store.state.campaign.campaign_roi.CampaignStatHeader
            .ReportingEndDate
      ) {
        return "table-success";
      }
    },
    back() {
      this.$router.go(-1);
    },
    as_dollar_modal(number) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(number);
    }
  },
  computed: {
    ...mapState(["dealer", "n_user"])
  },
  components: {
    cTable
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
